import libs from '../../libs'
import Supercluster from 'supercluster'

const state = {
  histories: {},
  history: {
    transmitter: null,
    start: null,
    end: null,
    features: [],
    index: 0,
    lastIndex: 0,
    indexed: {
      PING_TIME: null,
      LATITUDE: null,
      LONGITUDE: null,
      SPEED: 0,
      HEADING: 0
    },
    mode: 'stop',
    speed: 1,
    offset: 0,
    limit: 1,
    total: 0
  }
}

const getters = {
  histories: (state) => state.histories,
  history: (state) => state.history
}

const actions = {
  toInitHistory: async ({ state, dispatch, commit }) => {
    commit('setLoading', 'memuat data kapal')

    let firstHistoryIndex = null
    let firstHistory = null

    commit('setMapControl', { mode: 'history' })

    for (var historyIndex in state.histories) {
      await dispatch('toLoadHistory', historyIndex)

      if (firstHistoryIndex === null &&
        state.histories[historyIndex].features) {
        firstHistoryIndex = historyIndex
        firstHistory = state.histories[historyIndex]
      }
    }

    if (firstHistoryIndex) {
      commit('setKapal', firstHistory.kapal)
      commit('setHistory', {
        transmitter: firstHistory.transmitter,
        start: firstHistory.start,
        end: firstHistory.end,
        features: firstHistory.features
      })

      if (firstHistory.features[0]) {
        commit('setHistoryIndex', {
          index: 0,
          indexed: firstHistory.features[0].properties
        })

        dispatch('toZoom', {
          view: [
            state.history.indexed.LATITUDE,
            state.history.indexed.LONGITUDE
          ],
          zoom: 5
        })
      } else {
        commit('setMessage', {
          text: 'tidak ada data history tersedia',
          status: 400
        })
      }
    } else {
      dispatch('toRedraw')
    }

    commit('unsetLoading')
  },
  toLoadHistory: async ({ state, commit, dispatch }, historyIndex) => {
    const history = state.histories[historyIndex]
    const startDate = history.start.replace(',', '')
    const endDate = history.end.replace(',', '')

    const newQuery = libs.generateQuery({
      transmitter: history.transmitter,
      start: startDate,
      end: endDate
    })

    const histories = await dispatch('authenticatedApi', {
      method: 'get',
      url: `${window.config.BASEURL_API1}/history?${newQuery.toString}`
    })

    if (histories) {
      // make history cluster
      const cluster = new Supercluster({
        maxZoom: 16,
        radius: 32,
        reduce: (clusterProp) => {
          return histories.data.histories[clusterProp.index]
        }
      })

      cluster.load(histories.data.histories)

      commit('setHistories', {
        ...history,
        kapal: histories.data.kapal,
        features: histories.data.histories,
        cluster
      })
    }
  },
  toFirstTrack: ({ state, commit, dispatch }) => {
    const index = 0

    if (state.history.features[index]) {
      const indexed = state.history.features[index].properties

      commit('setHistoryIndex', { index, indexed })

      dispatch('toZoom', {
        view: [indexed.LATITUDE, indexed.LONGITUDE]
      })
    }
  },
  toPreviousTrack: ({ state, commit, dispatch }, index = false) => {
    if (index === false) {
      index = state.history.index - 1
    }

    if (state.history.features[index]) {
      const indexed = state.history.features[index].properties

      commit('setHistoryIndex', { index, indexed })

      dispatch('toZoom', {
        view: [indexed.LATITUDE, indexed.LONGITUDE]
      })
    }
  },
  toNextTrack: ({ state, commit, dispatch }, index = false) => {
    if (index === false) {
      index = state.history.index + 1
    }

    if (state.history.features[index]) {
      const indexed = state.history.features[index].properties

      commit('setHistoryIndex', { index, indexed })

      dispatch('toZoom', {
        view: [indexed.LATITUDE, indexed.LONGITUDE]
      })
    }
  },
  toLastTrack: ({ state, commit, dispatch }) => {
    const index = state.history.lastIndex

    if (state.history.features[index]) {
      const indexed = state.history.features[index].properties

      commit('setHistoryIndex', { index, indexed })

      dispatch('toZoom', {
        view: [indexed.LATITUDE, indexed.LONGITUDE]
      })
    }
  },
  toPlayTrack: ({ state, commit, dispatch }) => {
    commit('setHistoryMode', 'play')

    window.clearTimeout(window.SALMONTRACK_HISTORY_PLAY)

    window.SALMONTRACK_HISTORY_PLAY = window.setTimeout(() => {
      dispatch('toNextTrack', state.history.index + state.history.speed)

      if (state.history.index <= state.history.lastIndex) {
        dispatch('toPlayTrack')
      } else {
        dispatch('toPauseTrack')
      }
    }, 1000)
  },
  toPauseTrack: ({ commit }) => {
    commit('setHistoryMode', 'pause')

    window.clearTimeout(window.SALMONTRACK_HISTORY_PLAY)
  },
  toStopTrack: ({ commit, dispatch }) => {
    commit('setHistoryMode', 'stop')
    dispatch('toNextTrack', 0)

    window.clearTimeout(window.SALMONTRACK_HISTORY_PLAY)
  },
  toToggleTrack: ({ state, dispatch }) => {
    if (state.history.mode === 'play') {
      dispatch('toPauseTrack')
    } else if (state.history.mode === 'pause') {
      dispatch('toPlayTrack')
    } else if (state.history.mode === 'stop') {
      dispatch('toPlayTrack')
    }
  },
  toChangeSpeed: ({ state, commit }) => {
    if (state.history.speed >= 10) {
      commit('setHistorySpeed', 1)
    } else {
      commit('setHistorySpeed', state.history.speed + 1)
    }
  },
  toAddHistory: ({ state, commit }) => {
    if (state.history.transmitter) {
      if (typeof state.histories[`index_${state.history.transmitter}`] !== 'undefined') {
        commit('setHistoriesStart', {
          transmitter: state.history.transmitter,
          start: state.history.start
        })
        commit('setHistoriesEnd', {
          transmitter: state.history.transmitter,
          end: state.history.end
        })
      } else {
        commit('setHistories', {
          transmitter: state.history.transmitter,
          start: state.history.start,
          end: state.history.end
        })
      }
    }

    if (state.histories['index_']) {
      commit('setHistoryOffset', 'index_')

      return
    }

    let startTime = new Date()
    let endTime = new Date()

    startTime.setTime(startTime.getTime() + (1000 * 60 * 60))
    endTime.setTime(endTime.getTime() + (1000 * 60 * 60 * 24 * 30))

    startTime = startTime.toLocaleString('en-CA', { hourCycle: 'h23'})
    endTime = endTime.toLocaleString('en-CA', { hourCycle: 'h23'})

    commit('setHistories', {
      transmitter: '',
      start: endTime,
      end: startTime
    })
    commit('setHistoryOffset', state.history.offset)
  },
  toRemoveHistory: ({ state, commit }) => {
    if (state.history.total <= 1) return

    delete state.histories[`index_${state.history.transmitter}`]

    if (state.history.offset > 0) {
      commit('setHistoryOffset', state.history.offset - 1)
    } else {
      commit('setHistoryOffset', 0)
    }

    state.history.total -= 1
  }
}

const mutations = {
  resetHistory: (state) => {
    state.histories = {},
    state.history = {
      transmitter: null,
      start: null,
      end: null,
      features: [],
      index: 0,
      lastIndex: 0,
      indexed: {
        PING_TIME: null,
        LATITUDE: null,
        LONGITUDE: null,
        SPEED: 0,
        HEADING: 0
      },
      mode: 'stop',
      speed: 1,
      offset: 0,
      limit: 1,
      total: 0
    }
  },
  setHistories: (state, history) => {
    if (typeof state.histories['index_'] === 'undefined') {
      if (typeof state.histories[`index_${history.transmitter}`] === 'undefined') {
        state.history.total += 1
      }

      state.histories[`index_${history.transmitter}`] = {
        transmitter: history.transmitter,
        start: history.start,
        end: history.end,
        kapal: history.kapal || {},
        features: history.features || {},
        cluster: history.cluster || []
      }
    } else {
      if (state.history.offset === state.histories['index_'].offset) {
        const currentHistory = state.histories['index_']

        currentHistory.transmitter = history.transmitter
        currentHistory.start = history.start
        currentHistory.end = history.end

        state.histories[`index_${history.transmitter}`] = currentHistory

        if (currentHistory.transmitter) {
          delete state.histories['index_']
        }
      } else {
        state.histories[`index_${history.transmitter}`].start = history.start
        state.histories[`index_${history.transmitter}`].end = history.end
      }
    }

    let offset = 0

    for (let historyIndex in state.histories) {
      if (historyIndex === `index_${history.transmitter}`) {
        break;
      }

      offset += 1
    }

    state.history.offset = offset
    state.histories[`index_${history.transmitter}`].offset = offset
  },
  setHistoriesStart: (state, { transmitter, start }) => {
    state.histories[`index_${transmitter}`].start = start
  },
  setHistoriesEnd: (state, { transmitter, end }) => {
    state.histories[`index_${transmitter}`].end = end
  },
  setHistory: (state, { transmitter, start, end, features }) => {
    state.history.transmitter = transmitter
    state.history.start = start
    state.history.end = end
    state.history.features = features || []
    state.history.lastIndex = state.history.features.length - 1
  },
  setHistoryIndex: (state, { index, indexed }) => {
    state.history.index = parseInt(index)
    state.history.indexed = indexed
  },
  setHistoryMode: (state, mode) => {
    state.history.mode = mode
  },
  setHistorySpeed: (state, speed) => {
    state.history.speed = speed
  },
  setHistoryStart: (state, start) => {
    state.history.start = start
  },
  setHistoryEnd: (state, end) => {
    state.history.end = end
  },
  setHistoryOffset: (state, selectedOffset) => {
    let offset = 0
    let selectedIndex = null
    let selectedHistory = null

    for (let historyIndex in state.histories) {
      if (offset === selectedOffset ||
        historyIndex === selectedOffset) {
        selectedIndex = historyIndex
        selectedHistory = state.histories[historyIndex]

        break
      }

      offset += 1
    }

    if (selectedIndex !== null) {
      state.history.transmitter = selectedHistory.transmitter
      state.history.start = selectedHistory.start
      state.history.end = selectedHistory.end
      state.history.features = selectedHistory.features
      state.history.lastIndex = selectedHistory.features.length - 1
      state.history.offset = offset
    }
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
